module.exports = __webpack_public_path__ + "media/images/game_icon/en/AB1002-161f78209db18d3576d038f63e7f3e61.png";